import styled from 'styled-components';

import { Button } from '@/shared/components/button';

export const Container = styled.div`
  background: rgb(255, 255, 255);
  padding: 0.75rem 1rem 0.75rem 0;
  border-radius: 0.3rem;
  box-shadow:
    rgba(43, 42, 42, 0.2) 0 1rem 2rem -0.5rem,
    rgba(0, 0, 0, 0.4) 0 0.2rem 1rem -0.7rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  width: calc(100% - 2rem);
  left: 1rem;
  min-height: 4rem;
`;

export const Avatar = styled.img`
  position: absolute;
  left: 1rem;
  bottom: calc(50% - 75px);
  border-radius: 50%;
  background: rgb(234, 234, 234);
  border: 0.25rem solid rgb(255, 255, 255);
  overflow: hidden;
  display: block;
  width: 7.5rem;
  height: 7.5rem;
  border-radius: 50%;
  object-fit: cover;
`;

export const UsernameAndPlariumIdWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 9.5rem;
`;

export const Username = styled.span`
  font-size: 1.2rem;
  font-weight: 700;
  line-height: 1.5rem;
  color: ${({ theme }) => theme.tokens.colors.text[100]};
  user-select: text;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const PlariumIdHolder = styled.span`
  color: ${({ theme }) => theme.tokens.colors.text[200]};
  font-size: 0.7rem;
  font-weight: 400;
  line-height: 1rem;
  white-space: nowrap;
  user-select: text;
`;

export const Buttons = styled.div`
  display: flex;
  gap: 0.75rem;
`;

export const ActionButton = styled(Button)`
  min-width: auto;
`;
